module.exports = __webpack_public_path__ + "static/media/Värde-Baserad Försäljning.a72ba291.pdf";